import { SelfCheckIn } from '@/api/interface/self-check-in'
import Colors from '@/styles/Colors.module.scss'
import { EventHandler } from 'react'
import dynamic from "next/dynamic"
import check from "public/animations/check.json"


interface Props {
  settings: SelfCheckIn['settings']
  handleCloseDialog: EventHandler<any>
}

const Lottie = dynamic(() => import('react-lottie-player/dist/LottiePlayerLight'), { ssr: false })

export default function SuccessDialogContent({
  settings,
  handleCloseDialog,
}: Props) {
  return (
    <>
      <Lottie 
        animationData={check} 
        style={{ width: 120 }} 
        loop={false} 
        play
      />
      <h2 style={{ fontSize: 20, fontWeight: 700 }}>
        You've added yourself to the waitlist!
      </h2>
      <p style={{ margin: '20px 0' }}>
        Look out for a confirmation text on your phone and for further
        communication from the business. Happy waiting!
      </p>
      <button
        className="btn"
        style={{
          width: '100%',
          height: 60,
          fontSize: '1.25rem',
          fontWeight: 'bold',
          marginTop: '0.875rem',
          marginBottom: '1rem',
          borderRadius: '99px',
          backgroundColor:
            settings?.btnBackgroundColor || Colors['theme-green'],
          color: settings?.btnTextColor || Colors['theme-white'],
        }}
        onClick={(e) => {
          handleCloseDialog('closeButton')
        }}
      >
        Done
      </button>
    </>
  )
}
